<template>
  <!-- :class="isActive ? 'dropdown--active' : ''" -->
  <div
    class="ed-dropdown ed-dropdown--active"
    :class="customClass"
    v-click-outside="hide"
    :style="styles"
  >
    <div class="picker" @click="toggleActive">
      <p class="picker__text">{{ selected }}</p>
      <box-icon
        :name="isActive ? 'chevron-up' : 'chevron-down'"
        class="picker__icon"
      />
    </div>
    <div class="ed-dropdown__list-container" v-show="isActive">
      <!-- <input type="text" class="ed-dropdown__search" placeholder="Filter"> -->
      <ul class="ed-dropdown__list nav-overflow">
        <li
          class="ed-dropdown__item"
          v-for="item in listItems"
          :key="item"
          :class="activeTabClass(item)"
          @click="selectActive(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import clickOutside from '../../directives/click-outside';

export default {
  name: 'ed-dropdown',
  props: ['selected', 'listItems', 'isSelected', 'styles', 'customClass'],
  directives: {
    clickOutside,
  },
  data() {
    return {
      isActive: false,
    };
  },
  mounted() {
    if (this.selected.length < 1) {
      this.isSelected(this.listItems[0]);
    }
  },
  computed: {},
  methods: {
    toggleActive() {
      this.isActive = !this.isActive;
    },
    selectActive(tab) {
      this.isSelected(tab);
      this.toggleActive();
    },
    activeTabClass(tab) {
      return tab === this.selected ? 'ed-dropdown__item--active' : '';
    },
    hide() {
      this.isActive = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
